<style lang="scss" scoped>
  @import "@/assets/scss/vuexy/pages/Grid.scss";
</style>

<template>
    <div>
    <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button  @click="showFilters = !showFilters"  type="flat" color="grey" class="float-right hover:text-white">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle mr-2"><iconFilter/></iconBase>
          <span v-show="!showFilters"  class="font-bold">{{$t('Labels.ShowFilters')}}</span>
          <span v-show="showFilters"  class="font-bold">{{$t('Labels.HideFilters')}}</span>
        </vs-button>
      </div>
    </div>
    <div class="vx-row px-2 py-5" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Alias')}}</label>
        <vs-input class="w-full" v-model="filters.alias" />
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Relay')}} 1</label>
        <v-select class="align-middle" :options="state_values" v-model="filters.relay1_state" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Relay')}} 2</label>
        <v-select class="align-middle" :options="state_values" v-model="filters.relay2_state" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center hidden sm:inline-block sm:w-auto">
        <vs-button @click="doFilter()" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    <div class="vx-row px-2 py-5" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label  class="font-bold">{{$t('Labels.Temperature')}}</label>
        <vs-slider v-model="temp" :min="limits.temperature.min" :max="limits.temperature.max" text-fixed="°"/>
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label  class="font-bold">{{$t('Labels.Humidity')}}</label>
        <vs-slider v-model="hum" :min="limits.humidity.min" :max="limits.humidity.max" text-fixed="%"/>
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label  class="font-bold">{{$t('Labels.Co2')}}</label>
        <vs-slider v-model="ppm" :min="limits.co2.min" :max="limits.co2.max" text-fixed="ppm"/>
      </div>
      <div class="vx-col w-full text-center sm:hidden sm:w-auto">
        <vs-button @click="doFilter()" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    <div class="vx-row mb-5">
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="columnOrders" v-model="filters.byColumn" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder == 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder != 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.ByPage')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="byPage" v-model="filters.limit" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <a v-if="urlDownload.length > 0" class="btn-primary align-middle" :href="urlDownload" download="TemperaturaAmbiental.csv"><feather-icon icon="DownloadCloudIcon" /></a>
      </div>
    </div>
    <div class="grid-container">
        <div class="item-grid-view vx-row match-height mt-4 cursor-pointer">
            <div :key="item.objectID" @click="goToDetail(item.uuid)" class="vx-col lg:w-1/4 sm:w-1/2 w-full" v-for="item in response">
                <vx-card class="grid-view-item mb-base overflow-hidden">
                    <gridPrincipalItem
                      img="co2"
                      :name="item.alias"
                      :description="$t('Labels.Alias')"
                    ></gridPrincipalItem>
                    <vs-divider/>
                    <valueItem
                      :value="parseFloat(item.ppm_current).toFixed(2)"
                      :description="$t('Labels.MeterVirus')"
                      img="co2"
                      unit="ppm"
                      :min="'600'"
                      :max="'3000'"
                      :warning="'1000'"
                    />
                    <valueItem
                      :value="parseFloat(item.ppm_current).toFixed(2)"
                      :description="$t('Labels.airQuality')"
                      img="co2"
                      unit="ppm"
                      :min="'1000'"
                      :max="'3000'"
                      :warning="'1600'"
                    />
                    <valueItem
                      :value="parseFloat(item.temp_current).toFixed(2)"
                      :description="$t('Labels.Temperature')"
                      img="temperature"
                      unit="°C"
                      :min="item.temp_min"
                      :max="item.temp_max"
                    />
                    <valueItem
                      :value="parseFloat(item.hum_current).toFixed(2)"
                      :description="$t('Labels.Humidity')"
                      img="humedad"
                      unit="%"
                      :min="item.hum_min"
                      :max="item.hum_max"
                    />
                    <alertRelay :status="item.relay1_state === '1'? true: false" name="Relay 1" />
                    <alertRelay :status="item.relay2_state === '1'? true: false" name="Relay 2" />
                    <vs-divider/>
                    <valueItem
                      :value="item.updated_at.split(' ')[0]"
                      :description="item.updated_at.split(' ')[1]"
                      img="fecha"
                    ></valueItem>
                </vx-card>
            </div>
        </div>
        <vs-pagination :max="5" :total="totalPages" v-if="response" v-model="currentx">
        </vs-pagination>
    </div>
    </div>
</template>
<script>
import { request } from '@/request.js'
import vSelect from 'vue-select'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'
import iconFilter from '@/components/icons/iconFilter'
import alertRelay from '@/components/alertRelay/alertRelay.vue'

const DATA = {
  code: 200,
  data: {
    count: 2,
    rows: [
      {
        uuid: 'cdfbacef-3540-41b5-aae3-448bcd330df4',
        deveui: '0011223344556677',
        serial: '1111111',
        alias: 'sensor 1 co2',
        label_location: 'en la biblioteca planta baja',
        notes: 'alguna nota extra no obligatiora',
        ppm_current: '800',
        ppm_max: '1000',
        ppm_min: '500',
        temp_current: '28.01',
        temp_max: '30.01',
        temp_min: '25.01',
        hum_current: '50',
        hum_max: '60',
        hum_min: '30',
        relay1_state: '0',
        relay2_state: '1',
        latlong: '20.6738686,-103.3704324',
        created_at: '2021-08-20 17:29:11',
        updated_at: '2021-08-23 11:08:06'
      },
      {
        uuid: 'cdfbacef-3540-41b5-aae3-448bcd450df4',
        deveui: '7766554433221100',
        serial: '222222',
        alias: 'sensor 2 co2',
        label_location: 'en la biblioteca planta alta',
        notes: 'alguna nota extra no obligatiora',
        ppm_current: '800',
        ppm_max: '1000',
        ppm_min: '500',
        temp_current: '28.01',
        temp_max: '30.01',
        temp_min: '25.01',
        hum_current: '50',
        hum_max: '60',
        hum_min: '30',
        relay1_state: '0',
        relay2_state: '1',
        latlong: '20.6738686,-103.3704345',
        created_at: '2021-08-20 17:29:11',
        updated_at: '2021-08-23 11:08:06'
      }
    ]
  },
  msg: 'Ok'
}

export default {
  components: {
    'v-select': vSelect,
    gridPrincipalItem,
    valueItem,
    iconBase,
    iconFilterAsc,
    iconFilterDesc,
    iconFilter,
    alertRelay
  },
  data () {
    return {
      response: [],
      currentx: 1,
      totalPages: 0,
      state_values: [
        { label: 'Todos', value: '' },
        { label: this.$t('Messages.Off'), value: 0 },
        { label: this.$t('Messages.On'), value: 1 }
      ],
      filters: {
        limit: 20,
        offset: 0,
        byColumn: 'updated_at',
        byOrder: 'ASC',
        alias: '',
        temp_min: '',
        temp_max: '',
        hum_min: '',
        hum_max: '',
        ppm_max: '',
        ppm_min: '',
        relay1_state: '',
        relay2_state: ''
      },
      temp: [0, 100],
      hum: [0, 100],
      ppm: [0, 5000],
      urlDownload: '',
      showFilters: false,
      limits: {
        temperature: {
          min: 0,
          max: 100
        },
        humidity: {
          min: 0,
          max: 100
        },
        co2: {
          min: 0,
          max: 5000
        }
      },
      columnOrders: [
        { label: this.$t('Labels.Alias'), value: 'alias' },
        { label: this.$t('Labels.Date'), value: 'updated_at' }
      ],
      byPage: [
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 75, value: 75 },
        { label: 100, value: 100 }
      ],
      data: DATA
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()
      this.filters.temp_min = this.temp[0]
      this.filters.temp_max = this.temp[1]
      this.filters.hum_min = this.hum[0]
      this.filters.hum_max = this.hum[1]
      this.filters.ppm_min = this.ppm[0]
      this.filters.ppm_max = this.ppm[1]

      const params = {
        url: 'co2_devices',
        method: 'GET',
        params: this.filters
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        if (response.data.limits !== undefined && this.limits !== response.data.limits) {
          this.limits = response.data.limits
          this.hum[0] = this.limits.humidity.min
          this.hum[1] = this.limits.humidity.max
          this.temp[0] = this.limits.temperature.min
          this.temp[1] = this.limits.temperature.max
          this.ppm[0] = this.limits.co2.min
          this.ppm[1] = this.limits.co2.max
        }
        this.setPages(response.data.data.count)
        this.createCsv()
      }).catch(() => {
        this.response = []
        this.setPages(0)
      }).finally(() => {
        this.$vs.loading.close()
      })
    },

    goToDetail (uuid) {
      window.location.href = `/co/detail/${uuid}`
    },

    createCsv () {
      const csv = []
      const headers = []
      headers.push(this.$t('Labels.Alias'))
      headers.push(this.$t('Labels.Co2'))
      headers.push(this.$t('Labels.Temperature'))
      headers.push(this.$t('Labels.Humidity'))
      headers.push(this.$t('Labels.Date'))
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(item.alias)
        row.push(`${item.ppm_current}ppm`)
        row.push(`${item.temp_current}°C`)
        row.push(`${item.hum_current}%`)
        row.push(item.updated_at)
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    },
    resetFilters () {
      this.filters.alias = ''
      this.filters.relay1_state = ''
      this.filters.relay2_state = ''
      this.hum[0] = this.limits.humidity.min
      this.hum[1] = this.limits.humidity.max
      this.temp[0] = this.limits.temperature.min
      this.temp[1] = this.limits.temperature.max
      this.ppm[0] = this.limits.co2.min
      this.ppm[1] = this.limits.co2.max
    },
    doFilter () {
      if (this.currentx !== 1) { this.currentx = 1 } else { this.getResponse() }
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getResponse()
    }

  },
  sockets: {
    co2 (payload) {
      this.response.forEach(toModify => {
        if (toModify.uuid === payload.uuid) {
          toModify.hum_current = payload.hum_current
          toModify.temp_current = payload.temp_current
          toModify.ppm_current = payload.ppm_current
          toModify.relay1_state = payload.relay1_state
          toModify.relay2_state = payload.relay2_state
          toModify.updated_at = payload.updated_at
        }
      })
      const temp = this.response
      this.response = []
      const app = this
      setTimeout(function () {
        app.response = temp
      }, 10)
    }
  },
  created () {
    this.getResponse()
  },

  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    }
  }
}
</script>
